import { useSnackbar } from 'notistack';

import { useDialog } from '@setvi/shared/providers';

import { usePrintOrderStore } from '../../../store';
import { usePrintOrderCart } from '../../../hooks/use-print-order-cart';
import { CartDialog, CART_DIALOG_ID } from '../../cart-dialog';

export const usePrintOrderActionBar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog, closeDialog } = useDialog();
  const items = usePrintOrderStore(state => state.items);
  const { clearCart, isDeleting } = usePrintOrderCart();

  // Cancel: delete the server cart (spinner on the button), then the reset
  // clears the selection which unmounts the bar. Toast once the API is done.
  const handleCancel = async () => {
    try {
      await clearCart();
      enqueueSnackbar('Order cancelled.', { variant: 'success' });
    } catch {
      // error toast handled globally by the mutation cache
    }
  };

  const openPreview = () =>
    openDialog(<CartDialog onClose={() => closeDialog(CART_DIALOG_ID)} />, {
      id: CART_DIALOG_ID
    });

  return { items, isDeleting, handleCancel, openPreview };
};
